import Svg, { Mask, Path, Rect, ClipPath, G, Defs } from 'react-native-svg';

export function ProfileUnFilled({ width, height, color }) {
  return (
    <>
      <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
      >
        <G clipPath="url(#clip0_5535_8975)">
          <Path
            d="M8 0C5.67378 0 3.78125 1.89253 3.78125 4.21875C3.78125 6.54497 5.67378 8.4375 8 8.4375C10.3262 8.4375 12.2188 6.54497 12.2188 4.21875C12.2188 1.89253 10.3262 0 8 0ZM8 7.5C6.19072 7.5 4.71875 6.02803 4.71875 4.21875C4.71875 2.40947 6.19072 0.9375 8 0.9375C9.80928 0.9375 11.2812 2.40947 11.2812 4.21875C11.2812 6.02803 9.80928 7.5 8 7.5Z"
            fill={color}
          />
          <Path
            d="M13.2489 11.1936C12.0939 10.0208 10.5628 9.375 8.9375 9.375H7.0625C5.43725 9.375 3.90606 10.0208 2.75106 11.1936C1.60172 12.3606 0.96875 13.901 0.96875 15.5312C0.96875 15.7901 1.17862 16 1.4375 16H14.5625C14.8214 16 15.0312 15.7901 15.0312 15.5312C15.0312 13.901 14.3983 12.3606 13.2489 11.1936ZM1.92687 15.0625C2.16172 12.4036 4.37534 10.3125 7.0625 10.3125H8.9375C11.6247 10.3125 13.8383 12.4036 14.0731 15.0625H1.92687Z"
            fill={color}
          />
        </G>
        <Defs>
          <ClipPath id="clip0_5535_8975">
            <Rect width={width} height={height} fill="white" />
          </ClipPath>
        </Defs>
      </Svg>
    </>
  );
}
